var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-8 col-md-10" }, [
    _vm.typeFilters && _vm.typeFilters.length > 1
      ? _c(
          "div",
          { staticClass: "global-dealer-search__types" },
          _vm._l(_vm.typeFilters, function (filter) {
            return _c(
              "div",
              { key: filter.name, staticClass: "global-dealer-search__type" },
              [
                _c("input", {
                  staticClass: "form__input--checkbox checkbox-style--1",
                  attrs: { id: filter.name, type: "checkbox" },
                  domProps: { checked: filter.selected },
                  on: {
                    change: function ($event) {
                      return _vm.selectTypeFilter(
                        filter.name,
                        $event.target.checked
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "form__label", attrs: { for: filter.name } },
                  [_vm._v(_vm._s(filter.label))]
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }